import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Layout from './Layout';
import BOTablesDashboard from './BOTablesDashboard'; // Importa o novo componente

const BOTables = () => {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                {/* O Dashboard abre diretamente como página principal do BOTables */}
                <Route index element={<BOTablesDashboard />} />
            </Route>
        </Routes>
    );
};

export default BOTables;